<div class="cost-adjustment-display">
    <div>
        @if (!costAdjustmentControlsVisible && (extendedCostAdjustmentTypes && extendedCostAdjustmentTypes.length > 0)) {
            <button helpTooltip
                    helpContentId="asset-info.add-cost-adjustment"
                    class="cost-adjustment-button ace-btn btn-sm btn"
                    (click)="showCostAdjustments()">
                <i class="fa fa-plus"></i> Cost Adjustments
            </button>
        }
    </div>
    @if (costAdjustmentControlsVisible && (extendedCostAdjustmentTypes && extendedCostAdjustmentTypes.length > 0)) {
        <table class="cost-adjustment-table">
            <!-- <tr>
            <td>Unadjusted Value</td>
            <td></td>
            <td class="calculated-cost">{{ _getCostFieldSourceValue() }}</td>
          </tr> -->
            @for (ca of extendedCostAdjustmentTypes; track ca) {
                <tr>
                    <td>{{ ca.typeName }}</td>
                    <td>
                        @if (costAdjustments[ca.costAdjustmentTypeId]) {
                            <div>
                                <div class="adjustment-input-holder">
                                    <div class="input-group">
                                        <div class="input-group-text">$</div>
                                        <input type="number"
                                               [name]="'costAdjustmentAmount' + [ca.costAdjustmentTypeId]"
                                               class="form-control"
                                               [ngClass]="'costAdjustmentAmount' + [ca.costAdjustmentTypeId]"
                                               [(ngModel)]="costAdjustments[ca.costAdjustmentTypeId].adjustmentAmount"
                                               [disabled]="isCostInputDisabled([ca.costAdjustmentTypeId], false)"
                                               (change)="calculateCosts()">
                                    </div>
                                </div>
                                <div class="adjustment-input-holder">
                                    <div class="input-group">
                                        <div class="input-group-text">%</div>
                                        <input type="number"
                                               [name]="'costAdjustmentPercent' + [ca.costAdjustmentTypeId]"
                                               class="form-control"
                                               [ngClass]="'costAdjustmentPercent' + [ca.costAdjustmentTypeId]"
                                               [(ngModel)]="costAdjustments[ca.costAdjustmentTypeId].adjustmentPercentage"
                                               [disabled]="isCostInputDisabled([ca.costAdjustmentTypeId], true)"
                                               (change)="calculateCosts()">
                                    </div>
                                </div>
                            </div>
                        }
                    </td>
                    <td class="calculated-cost">{{ costAdjustmentEmpty(ca) ? '' : '(' + costAdjustmentCalculations[ca.costAdjustmentTypeId] + ')' }}</td>
                </tr>
            }
            <tr>
                <td colspan="2" helpTooltip
                    helpContentId="asset-info.adjusted-source-cost">
                    Adj. Source Cost
                </td>
                <td class="calculated-cost-total">{{ calculatedCost }}</td>
            </tr>
        </table>
    }
</div>
